import request from "../request";

/**
 * Обновить email пользователя
 * @param {string} newEmail
 * @return {Promise}
 */
export const changeEmailRestriction = (newEmail) => {
  return request({
    url: "/profile/email",
    type: "PATCH",
    addCSRFToken: true,
    data: {
      newEmail,
    },
  });
};